var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHero = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1463,
    height: 239,
    viewBox: "0 0 1463 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00479152 191.842C-0.357418 178.455 60.156 148.145 130.944 157.567C201.732 166.988 253.931 198.106 311.085 182.571C368.24 167.036 507.384 131.928 584.186 149.482C660.987 167.036 720.832 170.572 732.548 170.572C740.36 170.572 736.998 193.381 722.465 239L0.00479152 238.996C0.248441 216.485 0.248441 200.767 0.00479152 191.842Z",
    fill: "#FFD110",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1460.96 190.181C1461.32 176.695 1405.54 146.008 1334.23 155.499C1262.92 164.989 1210.34 196.335 1152.77 180.686C1095.19 165.038 955.029 129.672 877.664 147.355C800.299 165.038 721.735 171.316 732.548 170.572C739.757 170.076 736.809 191.999 723.704 236.343L1460.96 237.841C1460.71 215.058 1460.71 199.171 1460.96 190.181Z",
    fill: "#FFD110",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.628 0C360.681 0 444.221 84.0044 444.221 187.629C444.221 202.836 442.422 217.621 439.026 231.779H76.2305C72.8345 217.621 71.0354 202.836 71.0354 187.629C71.0354 84.0044 154.576 0 257.628 0Z",
    fill: "url(#paint0_linear_1_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 175.654C0 182.739 131.445 214.905 223.253 170.971C315.06 127.037 395.068 147.484 503.627 170.971C576 186.629 650.872 187.821 728.245 174.548V237.841L0.224992 238.996C0.0749974 192.045 0 170.931 0 175.654Z",
    fill: "#FFD110",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.224976 204.182C0.224976 195.815 229.022 217.491 299.585 197.77C370.148 178.049 394.447 152.747 508.67 188.735C584.818 212.728 655.79 217.418 721.584 202.806L720.584 239L0.224976 237.793C0.224976 220.964 0.224976 209.761 0.224976 204.182Z",
    fill: "#FFD110"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1445.94 205.188C1445.94 196.821 1214.15 218.494 1143.58 198.773C1073.02 179.052 1048.72 153.75 934.499 189.739C858.35 213.731 787.045 218.084 720.584 202.798V238.801H1445.94C1445.94 221.97 1445.94 210.766 1445.94 205.188Z",
    fill: "url(#paint1_linear_1_3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1462.63 174.548C1462.63 181.685 1327.81 213.258 1235.32 169.001C1142.84 124.744 1062.25 145.342 952.894 169.001C879.991 184.774 805.108 186.623 728.245 174.548V237.525H1463C1462.76 190.783 1462.63 169.79 1462.63 174.548Z",
    fill: "#FFD110",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 257.628,
    y1: 0,
    x2: 257.628,
    y2: 144.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF833C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3",
    x1: 1083.26,
    y1: 171.575,
    x2: 1083.26,
    y2: 213.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF833C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD110"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHero);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero.221370c4135d6d008706b4ed3a7010bc.svg";